import { BaseError } from './base.js';
import { stringify } from 'viem';
export class HttpRequestError extends BaseError {
    constructor({ url, method, status, headers, body, details, }) {
        super('HTTP request failed.', {
            details,
            metaMessages: [
                status && `Status: ${status}`,
                `Method: ${method}`,
                `URL: ${url}`,
                body && `Request Body: ${stringify(body)}`,
            ].filter(Boolean),
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'HttpRequestError'
        });
        Object.defineProperty(this, "headers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "status", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "url", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "body", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "method", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.body = body;
        this.headers = headers;
        this.status = status;
        this.url = url;
        this.method = method;
    }
}
export class RpcRequestError extends BaseError {
    constructor({ url, body, error, }) {
        super('RPC request failed.', {
            cause: error,
            details: error.message,
            metaMessages: [
                `URL: ${url}`,
                `Request Body: ${stringify(body)}`,
                `Error: ${stringify(error)}`,
            ],
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'RpcRequestError'
        });
        Object.defineProperty(this, "code", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.code = error.code;
    }
}
export class TimeoutError extends BaseError {
    constructor({ url, body, method, }) {
        super('The request took too long to respond.', {
            details: `${method.toUpperCase()} ${url} timeout`,
            metaMessages: [
                `URL: ${url}`,
                `Request Body: ${stringify(body)}`,
                `Method: ${method}`,
            ],
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'TimeoutError'
        });
    }
}
//# sourceMappingURL=request.js.map